import { convertToPST } from 'app/helpers/dateHelper';
import { ITaskSearchCandidateBrand } from 'app/models/Tasks/Tasks';

/** PST date+time for task search grids (matches TasksSearchWrapper column formatting). */
export function formatTaskSearchGridDate(value: string | null | undefined): string {
  if (!value) return '—';
  const formatted = convertToPST(value, 'MM/DD/YYYY hh:mm A');
  if (formatted === 'Invalid Date' || formatted.includes('Invalid')) {
    return '—';
  }
  return formatted;
}

/** PST date-only for task search grids. */
export function formatTaskSearchGridDateOnly(value: string | null | undefined): string {
  if (!value) return '—';
  const formatted = convertToPST(value, 'MM/DD/YYYY');
  if (formatted === 'Invalid Date' || formatted.includes('Invalid')) {
    return '—';
  }
  return formatted;
}

export function idOrDash(val: number | null | undefined): string {
  return val != null && val !== 0 ? String(val) : '—';
}

export function numericIdSortComparator(v1: unknown, v2: unknown): number {
  const n1 = typeof v1 === 'number' && !Number.isNaN(v1) ? v1 : Number(v1);
  const n2 = typeof v2 === 'number' && !Number.isNaN(v2) ? v2 : Number(v2);
  const num1 = Number.isNaN(n1) ? Number.NEGATIVE_INFINITY : n1;
  const num2 = Number.isNaN(n2) ? Number.NEGATIVE_INFINITY : n2;
  return num1 - num2;
}

export function resolveTaskSearchCandidateBrandId(
  brands: ITaskSearchCandidateBrand[] | undefined,
  fallbackBrandId?: number | null,
): number | undefined {
  if (!brands?.length) {
    return fallbackBrandId ?? undefined;
  }
  if (fallbackBrandId != null) {
    const matchedBrand = brands.find(brand => brand.brandId === fallbackBrandId);
    if (matchedBrand) {
      return matchedBrand.brandId;
    }
  }
  return brands[0].brandId;
}
